import Scaffold from '~/components/Scaffold';

export const ManageAccess = () => {
  return <Scaffold title="Manage access" withBg={false} />;
};
